module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318699.318ce369.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318699.pdf
// module id = 835
// module chunks = 0